import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Grid} from '@daedalus/atlas/src/components/designSystem/helpers/Grid'
import {SkeletonLoader} from '@daedalus/atlas/src/components/designSystem/SkeletonLoader'

export const SkeletonWrapper = styled(Grid)(
  ({theme}) => css`
    width: 100%;
    background-color: ${theme.colors.background.neutral.c000};
    padding: ${theme.layout.spacing.s400}px;
    border-bottom: 1px solid ${theme.colors.border.brand.c100};
  `
)

// Keep the loader in sync with layout to prevent layout shift
export const Skeleton = () => (
  <SkeletonWrapper
    container
    alignItems="flex-start"
    justify="space-between"
    wrap="nowrap"
    spacing="s400"
  >
    <div>
      <SkeletonLoader width={100} height={24} />
      <SkeletonLoader width={135} height={24} marginTop={4} />
    </div>
    <div>
      <SkeletonLoader width={58} height={32} marginTop={12} align="right" />
      <SkeletonLoader width={85} height={20} marginTop={4} align="right" />
      <SkeletonLoader width={105} height={42} marginTop={12} align="right" />
    </div>
  </SkeletonWrapper>
)
